import { IAssertionDescriptorValidation, IStaticItemValidation } from './SameCaseEasyUpdate';
import { IMultiSelectOption, IStaticItemLookupModel } from '../../../interfaces/ILookup';

import { IAssertionDescriptorModel } from '../../../interfaces/IAssertionDescriptor';
import { ICaseAssertionModel } from '../../../interfaces/ICase';
import { IOrganizationBaseModel } from '../../../interfaces/IOrganization';
import { ISameCaseEasyUpdateCaseModel } from './ISameCaseEasyUpdateModel';
import { SelectedFieldForZone } from './SelectedFieldForZone';
import { cloneDeep } from 'lodash';

interface ISelectedFieldRowProps {
    assertionDescriptors: IAssertionDescriptorModel[];
    cases: ISameCaseEasyUpdateCaseModel[];
    field: IMultiSelectOption;
    onApplyToAllApplicableAssertionDescriptors: (
        assertionDescriptorGuid: string,
        caseAssertions?: ICaseAssertionModel[]
    ) => void;
    onApplyToAllApplicableStaticItems: (zoneGuid: string, staticItemId: number) => void;
    onRemoveField: (field: IMultiSelectOption) => void;
    onZoneCaseDataChange: (
        zoneGuid: string,
        newCaseModel: ISameCaseEasyUpdateCaseModel,
        refreshFields: boolean
    ) => void;
    staticItems: IStaticItemLookupModel[];
    validation: {
        assertionDescriptorValidation: IAssertionDescriptorValidation;
        staticItemValidation: IStaticItemValidation;
    };
    zones: IOrganizationBaseModel[];
    zonesWithErrors: string[];
}

export function SelectedFieldRow(props: ISelectedFieldRowProps) {
    const distinctZones = props.zones.filter(
        (zone, index, self) => index === self.findIndex((t) => t.guid === zone.guid)
    );

    const sortedZones = distinctZones.sort((a, b) => ((a.name ?? '') < (b.name ?? '') ? -1 : 1));

    return (
        <>
            {sortedZones.map((zone, i) => {
                const casesForZone = props.cases.filter(
                    (caseModel) => caseModel.organization?.guid === zone.guid
                );

                const isLastItem = i === sortedZones.length - 1;
                const isFirstItem = i === 0;

                return (
                    <>
                        {casesForZone.map((caseModel) => (
                            <SelectedFieldForZone
                                actionButtons={
                                    <>
                                        {isFirstItem && (
                                            <button
                                                type="button"
                                                className="btn btn-gray btn-icon float-end"
                                                onClick={() => props.onRemoveField(props.field)}
                                            >
                                                <i className="fal fa-times color-white" />
                                            </button>
                                        )}
                                    </>
                                }
                                assertionDescriptorGuid={props.field.guid}
                                assertionDescriptors={props.assertionDescriptors}
                                caseModel={caseModel}
                                isFirstItem={isFirstItem}
                                isLastItem={isLastItem}
                                key={zone.guid ?? '' + caseModel?.guid}
                                onApplyToAllApplicableAssertionDescriptors={
                                    props.onApplyToAllApplicableAssertionDescriptors
                                }
                                onApplyToAllApplicableStaticItems={
                                    props.onApplyToAllApplicableStaticItems
                                }
                                onZoneCaseDataChange={props.onZoneCaseDataChange}
                                rowLabel={isFirstItem ? props.field.label : ''}
                                staticItems={props.staticItems}
                                staticItemId={props.field.id}
                                validation={props.validation}
                                zone={zone}
                                zonesWithErrors={props.zonesWithErrors}
                            />
                        ))}
                    </>
                );
            })}
        </>
    );
}
